'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AppItemStatic", {
    enumerable: true,
    get: function() {
        return AppItemStatic;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useAppItemStatic = require("./useAppItemStatic");
const _renderAppItemStatic = require("./renderAppItemStatic");
const _useAppItemStaticStylesstyles = require("./useAppItemStaticStyles.styles");
const AppItemStatic = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useAppItemStatic.useAppItemStatic_unstable)(props, ref);
    (0, _useAppItemStaticStylesstyles.useAppItemStaticStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useAppItemStaticStyles_unstable')(state);
    return (0, _renderAppItemStatic.renderAppItemStatic_unstable)(state);
});
AppItemStatic.displayName = 'AppItemStatic';
